/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="14.81"
        height="14.81"
        viewBox="0 0 14.81 14.81"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M7.41 1.31c2.02 0 2.2 0 3.05.05.7.05 1.12.19 1.41.23.33.14.61.28.84.56.23.23.42.52.56.84.09.23.23.66.23 1.41.05.8.05 1.03.05 3.05s0 2.2-.05 3.05c-.05.7-.19 1.12-.23 1.41-.14.33-.28.61-.56.84-.28.23-.52.42-.84.56-.23.09-.66.23-1.41.23-.8.05-1.03.05-3.05.05s-2.2 0-3.05-.05c-.7-.05-1.12-.19-1.41-.23-.33-.14-.61-.28-.84-.56-.23-.28-.42-.52-.56-.84-.09-.23-.23-.66-.23-1.41-.05-.8-.05-1.03-.05-3.05s0-2.2.05-3.05c.05-.7.19-1.12.23-1.41.14-.33.28-.61.56-.84.23-.23.52-.42.84-.56.23-.09.66-.23 1.41-.23.8 0 1.03-.05 3.05-.05Zm0-1.31c-2.06 0-2.3 0-3.05.05-.8.05-1.31.19-1.83.33-.52.19-.89.42-1.31.84-.42.42-.7.84-.84 1.31a7.74 7.74 0 0 0-.33 1.83C0 5.16 0 5.44 0 7.41s0 2.3.05 3.05c.05.8.19 1.31.33 1.83s.42.89.84 1.31c.42.42.84.7 1.31.84.47.19 1.03.28 1.83.33s1.08.05 3.05.05 2.3 0 3.05-.05c.8-.05 1.31-.19 1.83-.33s.89-.42 1.31-.84.7-.84.84-1.31c.19-.47.28-1.03.33-1.83s.05-1.08.05-3.05 0-2.3-.05-3.05c-.05-.8-.19-1.31-.33-1.83-.19-.52-.42-.89-.84-1.31-.42-.42-.84-.7-1.31-.84a7.74 7.74 0 0 0-1.83-.33C9.66 0 9.43 0 7.41 0Z"
          fill="#4a4a4a"
          className="icon-fill"/>
        <path
          d="M7.41 3.61c-2.11 0-3.84 1.69-3.84 3.84s1.69 3.84 3.84 3.84 3.84-1.69 3.84-3.84-1.73-3.84-3.84-3.84Zm0 6.38c-1.36 0-2.53-1.13-2.53-2.53S6 4.93 7.41 4.93s2.53 1.12 2.53 2.53c-.05 1.41-1.17 2.53-2.53 2.53ZM11.39 4.36c.49 0 .89-.4.89-.89s-.4-.89-.89-.89-.89.4-.89.89.4.89.89.89Z"
          fill="#4a4a4a"
          className="icon-fill"/>
      </svg>

    );
  }
}

Icon.displayName = 'InstagramIcon';

export default Icon;
